import BaseService from './base-service'
import AuthService from './auth-service';
import ConfigurationService from './configuration-service';

const baseService = new BaseService();

var baseEndpoint: any = undefined;
var token: string = '';

class LoginService
{
    constructor()
    {
        this.setBaseEndpoint();
    }

    private setBaseEndpoint = async () =>
    { 
        baseEndpoint = await ConfigurationService.getConfiguration('ePharma.Authentication.Services.HTTPS');
    }

    static getLogin = async (username: string, password: string) =>
    {
        var endpoint = await ConfigurationService.getConfiguration('EndPoint.Authentication.Authenticate');
        token  = await AuthService.setTokenAuthenticationService();
        return baseService.getLogin(`${baseEndpoint + endpoint}`, token, username, password);
    }
}

export default LoginService;